"use client";
import React, { useState } from 'react';
import Image from 'next/image';
import "@/scss/_article.scss";
import profileIcon from '../../../public/icons/profile.svg';
import ArticleKeyTakaway from './ArticleKeyTakaway';
import LinkUnLikeSection from '../LinkUnLikeSection';
import CommentSection from '../CommentSection';
import SaveUnSave from '../SaveUnSave';

const MainArticleSection = ({ type, articleId, countLikes, countComments, countSaved, articleContent, keyTakeaways, sources, experts, authorName, authorProfile }) => {
  const [showSources, setShowSources] = useState(false);
  const [showExperts, setShowExperts] = useState(false);
  const [countLikesData, setCountLikesData] = useState(countLikes);
  const [countCommentsData, setCountCommentsData] = useState(countComments);
  const [countSavedData, setCountSavedData] = useState(countSaved);

  const getLikeCountStatus = (data) => {
    if(data){
      setCountLikesData(countLikesData + 1);
    } else {
      setCountLikesData(countLikesData - 1);
    }
  }

  const getSaveCountStatus = (data) => {
    if(data){
      setCountSavedData(countSavedData + 1);
    } else {
      setCountSavedData(countSavedData - 1);
    }
  }
  return (
    <div className="col-lg-8">
      {/* Right Sidebar - Key Takeaways */}
      <div className="col-lg-12 mb-5">
        <ArticleKeyTakaway keyTakeaways={keyTakeaways} />
      </div>
      <div className="article-body">
        {/* Article Content Section */}
        <div
          className="article-rich-content"
          dangerouslySetInnerHTML={{
            __html: articleContent || 'No content available',
          }}
        />
        {/* Author Bio */}
        <div className="author-bio mt-5">
          <div className="author-bio-content">
            <div className="author-bio-avatar">
              <Image src={profileIcon} alt="Author" width={60} height={60} />
            </div>
            <div className="author-bio-text">
              <h4 className="author-bio-name">Author {authorName}</h4>
              <p className="author-bio-description">
                {authorProfile?.bio}
              </p>
            </div>
          </div>
        </div>

        {/* Article Experts */}
        {/* {experts && (
                  <div className="article-sources mt-5">
                    <div className="sources-header" onClick={() => setShowExperts(!showExperts)}>
                      <h4 className="sources-title">Article Experts</h4>
                      <svg 
                        className={`sources-arrow ${showExperts ? 'open' : ''}`}
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M7 10l5 5 5-5" stroke="#0C0C0C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    {showExperts && (
                      <div className="sources-content">
                        <p dangerouslySetInnerHTML={{ __html: experts || 'No experts available' }} ></p>
                      </div>
                    )}
                  </div>
                )} */}

        {/* Article Sources */}
        <div className="article-sources mt-5">
          <div className="sources-header" onClick={() => setShowSources(!showSources)}>
            <h4 className="sources-title">Article Sources</h4>
            <svg
              className={`sources-arrow ${showSources ? 'open' : ''}`}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7 10l5 5 5-5" stroke="#0C0C0C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          {showSources && (
            <div className="sources-content">
              <p dangerouslySetInnerHTML={{ __html: sources || 'No sources available' }} ></p>
            </div>
          )}
        </div>

        {/* Engagement Metrics */}
        {type === 'article' && (
            <div className="engagement-metrics mt-4">
              <div className="engagement-item">
                <LinkUnLikeSection articleId={articleId} setLikeCountStatus={getLikeCountStatus} />
                <span>{countLikesData}</span>
              </div>
              <div className="engagement-item">
              <CommentSection  />
                <span>{countCommentsData}</span>
              </div>
              <div className="engagement-item">
              <SaveUnSave articleId={articleId} setSaveCountStatus={getSaveCountStatus} />
                <span>{countSavedData}</span>
              </div>
            </div>
        )}
      </div>
    </div>
  );
}

export default MainArticleSection;